<template>
	<transition 
			appear
			:appear-active-class="$_admin_stylePageAnimation()">
		<template v-if="initialized_">
			<v-container
					class="customVContainer fluid"
					:style="$_admin_stylePageContainerStyle()"
					fluid>
				<template v-if="$_admin_routeName == 'admin'">
					<admin-banner-layout
							:contents="$_admin_contents()"
							:inits="$_admin_inits()" />
				</template>
				<template v-else>
					<admin-tab-layout
							:contents="$_admin_contents()"
							:inits="$_admin_inits()" />
				</template>
			</v-container>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Index',
		data() {
			return {
				pageName_: 'admin',
				pageType_: 'admin',

				initialized_: false,
			}
		},
		computed: {
			// route
			$_admin_routeName() {
				const self_ = this;
				const route_ = self_.$route
				return route_.name
			},
			// params
			$_admin_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_admin_paramsOperationType() {
				const self_ = this;
				const params_ = self_.$_admin_params;
				if(self_.isEmpty(params_)) { return null }
				return self_.convertCaseToCamel(params_.operationType)
			},
			$_admin_paramsOperationName() {
				const self_ = this;
				const params_ = self_.$_admin_params;
				if(self_.isEmpty(params_)) { return null }
				return self_.convertCaseToCamel(params_.operationName)
			},
			// state
			$_admin_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			// contents / inits
			$_admin_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					if(self_.isFalse(self_.$_admin_paramsOperationType)) {
						return self_.getContentsSubset(contents_, 'isDummy', false)
					} else {
						return self_.getContentsSubset(contents_, 'operationType', self_.$_admin_paramsOperationType)	
					}
				}
			},
			$_admin_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// style
			$_admin_stylePage() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_admin_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_admin_inits(), 'page')
				}
			},
			$_admin_stylePageAnimation() {
				const self_ = this;
				return () => {
					const page_ = self_.$_admin_stylePage()
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.animation)
				}
			},
			$_admin_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_admin_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_admin_inits(), 'pageContainer')
			},
			$_admin_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_admin_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			},
		},
		watch: {
			$route() { 
				const self_ = this;
				if(self_.$_admin_routeName == 'admin') { self_.$_admin_updateRoute() }
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_admin_setPageState()

			if(self_.$_admin_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_admin_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)
			// udpate route			
			if(self_.$_admin_routeName == 'admin') { self_.$_admin_updateRoute() }
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_admin_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_admin_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_admin_initialize()', error)
				})
			},
			$_admin_updateRoute() {
				const self_ = this;
				const router_ = self_.$router;

				const operationType_ = self_.$_admin_paramsOperationType;
				const operationName_ = self_.$_admin_paramsOperationName;

				if(self_.isFalse(operationType_)) { return }

				// operation type & key
				if(operationType_ && operationName_) {
					router_.replace({
						name: 'adminOperationName',
						params: {
							operationType: operationType_,
							operationName: operationName_
						}
					})
				}
				// operation type
				else {
					router_.replace({
						name: 'adminOperationType',
						params: {
							operationType: operationType_
						}
					})
				}
			}
		}
	}
</script>

<style scoped>
</style>